const SupportedLocales = [
  {
    code: 'en',
    name: 'English'
  },
  {
    code: 'ko',
    name: '한국어'
  },
  {
    code: 'zh-TW',
    name: '繁體中文'
  },
  {
    code: 'zh-CN',
    name: '简体中文'
  },
  {
    code: 'jp',
    name: '日本語'
  },
  {
    code: 'es',
    name: 'Español'
  },
  {
    code: 'pt',
    name: 'Português'
  },
  {
    code: 'vi',
    name: 'Tiếng Việt'
  },
  {
    code: 'th',
    name: 'ไทย'
  },
  {
    code: 'fil',
    name: 'Filipino'
  },
  {
    code: 'id',
    name: 'Bahasa Indonesia'
  }
];

export default SupportedLocales;
